<div class="loader-fullscreen" [class.dark]="isDarkMode">
  <div class="loader-content">
    <div #animationContainer class="animation-container"></div>

    <div class="progress-wrapper">
      <div class="status-container">
        <span class="status">{{ loadingStatus }}</span>
      </div>

      <div class="progress-track">
        <div class="progress-fill" [style.width]="progressWidth"></div>
      </div>
    </div>
  </div>
</div>
